import React from 'react';
import { Link, Skeleton, Typography, useTheme } from '@mui/material';
import { Link as RouterLink, useNavigation } from 'react-router-dom';
import { ClientNameAndAvatar } from '@/components/table/ClientNameAndAvatar';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import { paths } from '@/app/routes';
import { getNameInitials } from '@/utils/constants';

export const DataGridAuditClientName = ({ clientId }) => {
	const navigation = useNavigation();
	const theme = useTheme();
	const isDarkMode = theme.palette.mode === 'dark';
	const { data: clientRow, isLoading } = useGetClientRowQuery(clientId, {
		skip: !clientId,
	});

	if (!clientId) {
		return (
			<Typography variant='body2' color='text.secondary'>
				—
			</Typography>
		);
	}

	if (isLoading) {
		return <Skeleton variant='text' width='8em' />;
	}

	const clientLink = `${paths.clients}/${clientId}`;
	const name = clientRow?.name ?? clientId;
	const isLoadingClient =
		navigation.state === 'loading' && navigation?.location?.pathname?.includes(clientId);

	return (
		<Link
			to={clientLink}
			component={RouterLink}
			underline='hover'
			sx={{ textDecorationLine: 'none', width: '100%' }}
		>
			<ClientNameAndAvatar
				title={name}
				initials={getNameInitials(name)}
				width={250}
				colour={
					isLoadingClient
						? isDarkMode
							? theme.palette.folioPurpleAccentMid
							: theme.palette.folioPurpleAccent
						: theme.palette.primary.main
				}
				titleSx={{
					fontWeight: 600,
					'&:hover': {
						textDecoration: 'underline',
					},
				}}
			/>
		</Link>
	);
};
